const documentsPath = "/fortress-fund/documents";
const documentLinkSelector = ".table__download a[href]";

export function initDocumentLinks() {
  if (!isDocumentsPage()) {
    return;
  }

  document.querySelectorAll(documentLinkSelector).forEach(setBlankTarget);
}

function isDocumentsPage() {
  return window.location.pathname.indexOf(documentsPath) !== -1;
}

function setBlankTarget(link) {
  link.setAttribute("target", "_blank");
  link.setAttribute("rel", mergeRelValues(link.getAttribute("rel")));
}

function mergeRelValues(currentValue) {
  const values = (currentValue || "").split(/\s+/).filter(Boolean);

  ["noopener", "noreferrer"].forEach(function(value) {
    if (values.indexOf(value) === -1) {
      values.push(value);
    }
  });

  return values.join(" ");
}
